import { createSlice } from '@reduxjs/toolkit';
import { Centrifuge } from 'centrifuge';

export const centrifugoSlice = createSlice({
  name: 'centrifugo',
  initialState: {
    isConnected: false,
    instance: undefined,
    tokens: undefined,
    channels: undefined,
  },
  reducers: {
    setCentrifugoConnected: (state, action) => ({
      ...state,
      isConnected: action.payload,
    }),
    setCentrifugoInstance: (state, action) => ({
      ...state,
      instance: action.payload,
    }),
    setCentrifugoTokens: (state, action) => ({
      ...state,
      tokens: action.payload,
    }),
    setCentrifugoChannels: (state, action) => ({
      ...state,
      channels: action.payload,
    }),
    resetCentrifugoChannels: (state, action) => {
      if (!state.instance) return;
      const instance = state.instance as Centrifuge;
      const subscriptions = instance.subscriptions();

      for (const subscription of Object.values(subscriptions)) {
        subscription.removeAllListeners();
        subscription.unsubscribe();
      }

      instance.disconnect();
    },
  },
});

export const {
  setCentrifugoConnected,
  setCentrifugoInstance,
  setCentrifugoTokens,
  setCentrifugoChannels,
  resetCentrifugoChannels,
} = centrifugoSlice.actions;
export const getCentrifugoChannels = (state: any) => state.centrifugo.channels;
export const getCentrifugoTokens = (state: any) => state.centrifugo.tokens;

export default centrifugoSlice.reducer;
